import { Checkbox, Modal, Table, type TableColumn } from '@viapeople/components'
import { useEffect, useState } from 'react'

interface AddHierarchiesLevelModalProps {
	isOpen: boolean
	onSelect: (levels: number[], id?: string) => void
	onClose: () => void
	currentValues: () => number[]
}

export const AddHierarchiesLevelModal: React.FC<AddHierarchiesLevelModalProps> = ({
	isOpen,
	onSelect,
	onClose,
	currentValues,
}) => {
	const [selectedLevels, setSelectedLevels] = useState<number[]>(currentValues)

	useEffect(() => {
		setSelectedLevels(currentValues())
	}, [currentValues])

	const hierarchyLevels = [3, 2, 1, -1, -2, -3].map((level) => ({
		id: level,
		name: `Level ${level}`,
	}))

	const columns: TableColumn<{ id: number; name: string }>[] = [
		{
			field: 'id',
			width: '40px',
			renderHeader: () => (
				<Checkbox
					checked={selectedLevels.length === hierarchyLevels.length}
					onChange={() => {
						if (selectedLevels.length === hierarchyLevels.length) {
							setSelectedLevels([])
						} else {
							setSelectedLevels(hierarchyLevels.map((level) => level.id))
						}
					}}
				/>
			),
			render: (item) => (
				<Checkbox
					checked={selectedLevels.includes(item.id)}
					onChange={() => {
						const newSelected = selectedLevels.includes(item.id)
							? selectedLevels.filter((id) => id !== item.id)
							: [...selectedLevels, item.id]
						setSelectedLevels(newSelected)
					}}
				/>
			),
		},
		{
			field: 'name',
			label: 'Level',
		},
	]

	return (
		<Modal
			buttons={[
				{
					children: 'Cancel',
					variant: 'secondary',
					onClick: (e) => {
						e.preventDefault()
						onClose()
					},
				},
				{
					children: 'Add levels',
					variant: 'primary',
					onClick: (e) => {
						e.preventDefault()
						if (selectedLevels.length > 0) {
							onSelect(selectedLevels)
						}
						onClose()
					},
					disabled: selectedLevels.length === 0,
				},
			]}
			isOpen={isOpen}
			onClose={onClose}
			fullContent
			title='Add Hierarchy Levels'>
			<Table data={hierarchyLevels} columns={columns} noBorder />
		</Modal>
	)
}
